import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as SettingsTabs from "./Tabs";
import { CustomTabs } from "components";

const AdminSettings = () => {
  const [activeKey, setActiveKey] = useState("1");
  const allItems = [
    {
      key: "1",
      label: "Profile",
      content: <SettingsTabs.Profile />,
    },
    {
      key: "2",
      label: "Security Settings",
      content: <SettingsTabs.SecuritySettings />,
    },
    {
      key: "3",
      label: "Notifications",
      content: <SettingsTabs.Notifications />,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  useEffect(() => {
    setActiveKey(tab || "1");
  }, [tab]);

  const handleTabChange = (key) => {
    setActiveKey(key);
    searchParams.set("tab", key);
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  return (
    <div className="w-full h-full">
      <div className="relative -z-1 min-h-[750px] w-[100%] lg:w-[98%] h-full ml-auto shadow-[0_4px_10px_rgba(0,0,0,0.1)] dark:shadow-[0_0px_3px_rgba(255,255,255,0.5)] flex flex-col mb-16 md:rounded-bl-md overflow-auto">
        <div className="bg-secondary w-full px-6 py-4 flex flex-col gap-1 items-start">
          <p className="text-white text-2xl font-bold">Settings</p>
        </div>
        <CustomTabs
          tabs={allItems}
          activeKey={activeKey}
          onChange={handleTabChange}
        />
      </div>
    </div>
  );
};

export default AdminSettings;
